// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34_lN","index":"styles_index__9pP-L"};